export enum DownloadCategory {
  Driver = 'Driver',
  Component = 'Component',
  Software = 'Software',
  Support = 'Support',
  LegacyDriver = 'Legacy Driver',
}

export interface DownloadData {
  Components: Components[];
  IntroductionDrivers: Driver[];
  CurrentReleaseDrivers: Driver[];
  OlderReleaseDrivers: Driver[];
  LegacyDrivers: LegacyDrivers[];
  Software: Software[];
  Support: Driver[];
  debugInfo: any; // Only for SuperUser Info
}

export interface Components {
  Files: FileData[];
  IsComponents: boolean;
  MainComponentItemIds: string;
  SN: string;
  Title: string;
}

export interface FileData {
  File: string;
  FileName: string;
  FolderName: string;
  Id: string;
  EntityGuid: string;
  Product: string;
  Target: string;
  Title: string;
  DownloadUrl?: string;
}

export interface LegacyDrivers {
  Title: string;
  Driver: Driver[];
}

export interface Driver {
  File: string;
  FileName: string;
  FolderName: string;
  Id: string;
  EntityGuid: string;
  Product: string;
  Target: string;
  Title: string;
  DownloadUrl?: string;
  MatlabVersion?: string;
}

export interface Software extends Driver {
  IsSpecificSoftwareImplementation: boolean;
}

export interface Categories {
  EntityId: number;
  NotesAfter: string;
  NotesBefore: string;
  IntroductionNotesBefore: string;
  IntroductionNotesAfter: string;
  CurrentReleaseNotesBefore: string;
  CurrentReleaseNotesAfter: string;
  OlderReleasesNotesBefore: string;
  OlderReleasesNotesAfter: string;
  RenewSubscriptionInfo: string;
  Title: string;
}
